<template>
  <form class="contact-form" @submit.prevent="submitForm">
    <h3>Contacte-nos</h3>

    <div v-if="status === 'success'" class="form-message success">
      ✅ Mensagem enviada com sucesso!
    </div>
    <div v-else-if="status === 'error'" class="form-message error">
      ❌ Erro ao enviar. Tente novamente.
    </div>

    <template v-if="status !== 'success'">
      <input v-model="form.name" type="text" placeholder="Nome" required />
      <input v-model="form.email" type="email" placeholder="Email" required />
      <textarea v-model="form.message" placeholder="Mensagem" required></textarea>
      <button type="submit" :disabled="sending">
        {{ sending ? 'A enviar...' : 'Enviar' }}
      </button>
    </template>

    <div class="supporters">
      <span v-for="company in companies" :key="company.name">
        <img :src="company.logo" :alt="company.name" width="48" />
      </span>
    </div>
  </form>
</template>

<script>
export default {
  name: 'ContactForm',
  data() {
    return {
      form: {
        name: '',
        email: '',
        message: '',
      },
      sending: false,
      status: null,
      companies: [
        { name: 'Empresa A', logo: 'https://scontent-lis1-1.xx.fbcdn.net/v/t1.6435-9/104175276_2660039840981349_4780844697803631474_n.jpg?_nc_cat=106&ccb=1-7&_nc_sid=1d70fc&_nc_ohc=whR2jnjbBk4Q7kNvwGSGdWH&_nc_oc=Adlh8fqALFY-of0otpfrMJPEefVSCehLnxSkDyahrKY-BCwSNl__kSWrfBJGwqf_hEg&_nc_zt=23&_nc_ht=scontent-lis1-1.xx&_nc_gid=E5i9tU8Mg09IeWPotEj0HQ&_nc_ss=8&oh=00_AfxcvSF63HrpGqyti8NWVT0jp5OvTnBppyAcxRT4JEY0Yg&oe=69CE4A25' },
        { name: 'Empresa B', logo: 'https://scontent-lis1-1.xx.fbcdn.net/v/t1.6435-9/104175276_2660039840981349_4780844697803631474_n.jpg?_nc_cat=106&ccb=1-7&_nc_sid=1d70fc&_nc_ohc=whR2jnjbBk4Q7kNvwGSGdWH&_nc_oc=Adlh8fqALFY-of0otpfrMJPEefVSCehLnxSkDyahrKY-BCwSNl__kSWrfBJGwqf_hEg&_nc_zt=23&_nc_ht=scontent-lis1-1.xx&_nc_gid=E5i9tU8Mg09IeWPotEj0HQ&_nc_ss=8&oh=00_AfxcvSF63HrpGqyti8NWVT0jp5OvTnBppyAcxRT4JEY0Yg&oe=69CE4A25' },
        { name: 'Empresa C', logo: 'https://scontent-lis1-1.xx.fbcdn.net/v/t1.6435-9/104175276_2660039840981349_4780844697803631474_n.jpg?_nc_cat=106&ccb=1-7&_nc_sid=1d70fc&_nc_ohc=whR2jnjbBk4Q7kNvwGSGdWH&_nc_oc=Adlh8fqALFY-of0otpfrMJPEefVSCehLnxSkDyahrKY-BCwSNl__kSWrfBJGwqf_hEg&_nc_zt=23&_nc_ht=scontent-lis1-1.xx&_nc_gid=E5i9tU8Mg09IeWPotEj0HQ&_nc_ss=8&oh=00_AfxcvSF63HrpGqyti8NWVT0jp5OvTnBppyAcxRT4JEY0Yg&oe=69CE4A25' },
      ],
    };
  },
  methods: {
    async submitForm() {
      this.sending = true;
      this.status = null;
      try {
        const res = await fetch('https://formsubmit.co/ajax/andretome91+anam@gmail.com', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            name: this.form.name,
            email: this.form.email,
            message: this.form.message,
            _subject: 'Nova mensagem do site Karate ANAM',
          }),
        });
        if (res.ok) {
          this.status = 'success';
          this.form = { name: '', email: '', message: '' };
        } else {
          this.status = 'error';
        }
      } catch (e) {
        this.status = 'error';
      }
      this.sending = false;
    },
  },
};
</script>

<style scoped>
.contact-form {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  padding: 1rem;
  margin-top: 1rem;
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #333;
}
.contact-form h3 {
  color: #333;
  margin: 0 0 0.5rem;
}
.contact-form input,
.contact-form textarea {
  width: 90%;
  margin: 0.5rem 0;
  padding: 0.5rem;
  border-radius: 4px;
  border: 1px solid #ccc;
  font-size: 1rem;
}
.contact-form button {
  background: #e53935;
  color: #fff;
  border: none;
  padding: 0.5rem 1.5rem;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 0.5rem;
  font-size: 1rem;
}
.contact-form button:disabled {
  background: #999;
  cursor: not-allowed;
}
.form-message {
  padding: 0.8rem 1rem;
  border-radius: 4px;
  width: 90%;
  text-align: center;
  font-weight: bold;
  margin: 0.5rem 0;
}
.form-message.success {
  background: #e8f5e9;
  color: #2e7d32;
  border: 1px solid #2e7d32;
}
.form-message.error {
  background: #fff5f5;
  color: #e53935;
  border: 1px solid #e53935;
}
.supporters {
  margin-top: 1rem;
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  justify-content: center;
}

@media (max-width: 480px) {
  .contact-form {
    padding: 0.8rem;
    margin: 1rem 0.5rem;
  }
  .contact-form input,
  .contact-form textarea {
    width: 100%;
  }
}
</style>

